module.exports = __webpack_public_path__ + "img/kuang2.3850dec6.png";